import { __makeTemplateObject } from "tslib";
import styled from '@marvelapp/styled';
import Box from './Box';
var Flex = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Flex.defaultProps = {
    display: 'flex',
};
export default Flex;
var templateObject_1;
